//@flow

import React, { useCallback, useState } from "react";

import { HiddenBruImage } from "@/components";
import * as sliderFrameStyle from "@/components/SliderFrame/slider-frame.module.scss";
import { classNameOf } from "@/utils";

type Props = {
    children?: React$Node,
    didLoad?: () => void,
    backgroundImage?: ImageSharp,
    className?: string,
    style?: any,
}

const SliderFrame = (props: Props): React$Element<"div"> => {
    const { didLoad } = props;
    const [style, setStyle] = useState({});

    const onCurrentSrcChange = useCallback(
        (newSource: string) => {
            setStyle(prevStyle => ({
                ...prevStyle,
                backgroundImage: `url('${newSource}')`,
            }));
            if (typeof didLoad === "function") {
                didLoad();
            }
        },
        [setStyle, didLoad],
    );

    return (
        <div
            {...{
                className: props.className,
                style: {
                    ...style,
                    ...(props?.style || {}),
                },
            }}
            className={classNameOf(
                props.className || "",
                sliderFrameStyle.slideFrame,
            )}
        >
            {props.backgroundImage ? (
                <HiddenBruImage
                    image={props.backgroundImage}
                    onCurrentSrcChange={onCurrentSrcChange}
                />
            ) : (
                <></>
            )}
            {props.children}
        </div>
    );
};

export default SliderFrame;
